import { Redirect, Route } from "react-router-dom";
import { IonApp, IonRouterOutlet, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import Home from "./pages/home/Home";
import { Login } from "./pages/login/Login";
import { SetPassword } from "./pages/setPassword/setPassword";
import { ForgotPassword } from "./pages/forgotPassword/forgotPassword";
import Header from "./components/Header/Header";
import { GlobalStore } from "./global/Store";
import { DataRepo } from "./data-repo/DataRepo";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import LogRocket from 'logrocket';
/* Theme variables */
import "./theme/variables.css";
import "./theme/jm.css";

import "bootstrap/dist/css/bootstrap.min.css";

setupIonicReact();

const App: React.FC = () => (
  <IonApp>
    <IonReactRouter>
      <IonRouterOutlet>
        <GlobalStore>
          <DataRepo>
            <Route exact path="/login">
              <Login />
            </Route>
            <Route exact path="/forgot-password">
              <ForgotPassword />
            </Route>
            <Route path="/set-password">
              <SetPassword />
            </Route>
            <Route exact path="/home">
              <Header></Header>
              <Home />
            </Route>
            <Route exact path="/">
              <Redirect to="/home" />
            </Route>
          </DataRepo>
        </GlobalStore>
      </IonRouterOutlet>
    </IonReactRouter>
  </IonApp>
);

export default App;
